import { baseApi, client } from '../baseApi.ts';

export const costEndpoints = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getTrueTouchCost: builder.query({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.cost.trueTouchCost();
					const data = response?.data;
					if (data != null && data.length) {
						return { data: data.map(({ min, max, credits }) => [min, max, credits]) };
					}
					return { data: [] };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['TrueTouchCost'],
		}),
		getUpscaleCost: builder.query({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.cost.upscaleCost();
					const data = response?.data;
					if (data != null) {
						return { data };
					}
					return { data: {} };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['UpscaleCost'],
		}),
		getLipSyncCost: builder.query({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.cost.lipSyncCost();
					const data = response?.data;
					const { credits_per_character: costPerCharacter, credits_per_second: costPerSecond } =
						data;
					return { data: { costPerCharacter, costPerSecond } };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['LipSyncCost'],
		}),
		getFaceReplaceCost: builder.query({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.cost.faceReplaceCost();
					const data = response?.data;
					if (data != null) {
						return { data: { credits: data?.credits_per_swap } };
					}
					return { data: {} };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['FaceReplaceCost'],
		}),
		getVideoAnyoneCost: builder.query({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.cost.videoAnyoneCost();
					const data = response?.data;
					if (data != null) {
						return { data };
					}
					return { data: {} };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['VideoAnyoneCost'],
		}),
		getVideoSwapCost: builder.query({
			// @ts-ignore
			queryFn: async (assetId: string) => {
				try {
					const response = await client.cost.videoSwapCost(assetId);
					const data = response?.data;
					return { data: { generationOptions: data?.generation_options } };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['VideoSwapCost'],
		}),
		getMusicVideoCost: builder.query({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.cost.musicVideoCost();
					const data = response?.data;
					if (data != null) {
						return { data };
					}
					return { data: {} };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['MusicVideoCost'],
		}),

		getGenerationCost: builder.query({
			// @ts-ignore
			queryFn: async (queryParams) => {
				try {
					const response = await client.cost.generationCost(queryParams);
					const data = response?.data;
					if (data != null) {
						return { data };
					}
					return { data: {} };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['ClothingChangeCost'],
		}),
	}),
});
